const notificationType = {
  OPERATION: {
    TYPE: 'operation.type'
  },
  SERVICES: {
    TYPE: 'services.type'
  },
  OWNERSHIP: {
    TYPE: 'ownership.type'
  }
}

export default notificationType
